import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      console.log('1. AuthCallback mounted');
      console.log('2. Full URL:', window.location.href);
      
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      const userDataStr = params.get('userData');
      
      console.log('3. URL Parameters:', {
        token: token ? `${token.substring(0, 20)}...` : null,
        userData: userDataStr ? `${userDataStr.substring(0, 20)}...` : null
      });

      if (!token || !userDataStr) {
        console.error('4a. Missing required parameters:', { 
          hasToken: !!token, 
          hasUserData: !!userDataStr 
        });
        return navigate('/login?error=missing_data');
      }

      try {
        console.log('4b. Attempting to parse user data');
        const userData = JSON.parse(userDataStr);
        console.log('5. Successfully parsed user data:', userData);

        // Store auth data
        localStorage.setItem('token', token);
        localStorage.setItem('userData', userDataStr);
        console.log('6. Stored auth data in localStorage');

        // Small delay to ensure storage is complete
        await new Promise(resolve => setTimeout(resolve, 100));

        console.log('7. Redirecting to dashboard');
        navigate('/dashboard');
      } catch (error) {
        console.error('Error in AuthCallback:', error);
        navigate('/login?error=callback_failed&message=' + encodeURIComponent(error.message));
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      padding: '20px'
    }}>
      <div style={{ 
        textAlign: 'center',
        maxWidth: '400px',
        padding: '20px',
        borderRadius: '8px',
        backgroundColor: '#f5f5f5'
      }}>
        <h2 style={{ marginBottom: '10px' }}>Processing Login...</h2>
        <p>Please wait while we complete your authentication.</p>
      </div>
    </div>
  );
};

export default AuthCallback; 